/* eslint-disable */
import { DatePicker } from "@mui/x-date-pickers";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import { getOrdenesEnvio } from "../../../project/services/OrdenEnvioService";
import OrdenEnvioDialog from "./OrdenEnvioDialog";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
  codigoOrdenEnvio: "",
  codigoGestionAtencion: "",
  sucursalGenera: "",
  sucursalEnvia: "",
  usuario: "",
  fechaCreacionDesde: null,
  fechaCreacionHasta: null,
  fechaEstadoDesde: null,
  fechaEstadoHasta: null,
  estadoActual: "preparando",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todas",
  },
  {
    id: "preparando",
    descripcion: "Preparando",
  },
  {
    id: "enviado",
    descripcion: "Enviadas",
  },
  {
    id: "recibido",
    descripcion: "Recibidas",
  },
];

const nameItemsText = "Ordenes de Envío";
//
// ################################################################################
//
const OrdenEnvioTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [ordenesEnvio, setOrdenesEnvio] = useState([]);
  const [areas, setAreas] = useState([]);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [idOrdenEnvio, setIdOrdenEnvio] = useState("");
  const [openOrdenEnvioDialog, setOpenOrdenEnvioDialog] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Orden Envío",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_creacion",
      headerName: "Fecha Creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_creacion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "codigo_gc",
      headerName: "Ges Com",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_gc;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "tipo_anteojo_arreglo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tipo_anteojo_arreglo == 'anteojo' ? "ANTEOJO" : "ARREGLO";
        return _val;
      },
    },
    {
      field: "codigo_gc_anteojo_arreglo",
      headerName: "Cód Ant/Arr",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_gc_anteojo_arreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_cliente + " " + params.row.apellido_cliente;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_corta_area_genera",
      headerName: "Suc. genera",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area_genera;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_corta_area_envia",
      headerName: "Suc. envía",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_corta_area_envia;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "usuario",
      headerName: "Vendedor",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {/* ver */}
          {params.row.action_ver === true && (
            <Tooltip title="acciones de la orden de envío">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickOrdenEnvioDetalles(params.row)}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadAreas();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData('area');
    if (response.ok) {
      const _response = response.data.data.filter(area => area.interno_externo === "interno" && area.actividad === "punto-de-venta");
      setAreas(_response);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickOrdenEnvioDetalles = (parRow) => {
    setIdOrdenEnvio(parRow.id);
    setOpenOrdenEnvioDialog(true);
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaEstadoDesde = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaEstadoDesde: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaEstadoHasta = (parFecha) => {
    setSearchData({
      ...searchData,
      fechaEstadoHasta: parFecha,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setTotalRowsCount(0);
    setOrdenesEnvio([]);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      codigoOrdenEnvio: searchData.codigoOrdenEnvio,
      codigoGestionAtencion: searchData.codigoGestionAtencion,
      sucursalGenera: searchData.sucursalGenera,
      sucursalEnvia: searchData.sucursalEnvia,
      fechaCreacionDesde: searchData.fechaCreacionDesde,
      fechaCreacionHasta: searchData.fechaCreacionHasta,
      estadoActual: searchData.estadoActual,
      fechaEstadoDesde: searchData.fechaEstadoDesde,
      fechaEstadoHasta: searchData.fechaEstadoHasta,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getOrdenesEnvio(_params);

    if (response.ok) {
      setIsDoingSomething(false);

      setTotalRowsCount(response.data.count);
      setOrdenesEnvio(response.data.data);
    } else {
      setIsDoingSomething(false);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleEnviaAProduccion = () => {
    setOpenOrdenEnvioDialog(false);
    load();
  };
  //
  // ################################################################################
  //
  const handleCloseOrdenEnvioDialog = () => {
    setOpenOrdenEnvioDialog(false);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                {areas.length > 0 && (
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel
                      id="sucursal-genera-select-label"
                      sx={{
                        transform: "translate(15px, 10px) scale(1)",
                        "&.MuiInputLabel-shrink": {
                          transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                        },
                      }}
                    >
                      Sucursal que genera
                    </InputLabel>
                    <Select
                      labelId="sucursal-genera-select-label"
                      id="sucursal-genera-select"
                      name="sucursalGenera"
                      value={searchData.sucursalGenera}
                      label="Sucursal que genera"
                      size="small"
                      onChange={handleChange}
                      MenuProps={{ style: { maxHeight: "300px" } }}
                    >
                      {areas.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                {areas.length > 0 && (
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel
                      id="sucursal-envia-select-label"
                      sx={{
                        transform: "translate(15px, 10px) scale(1)",
                        "&.MuiInputLabel-shrink": {
                          transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                        },
                      }}
                    >
                      Sucursal que envía
                    </InputLabel>
                    <Select
                      labelId="area-envia-select-label"
                      id="area-envia-select"
                      name="sucursalEnvia"
                      value={searchData.sucursalEnvia}
                      label="Sucursal que envía"
                      size="small"
                      onChange={handleChange}
                      MenuProps={{ style: { maxHeight: "300px" } }}
                    >
                      {areas.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoOrdenEnvio"
                  label="Código de Orden de Envío"
                  variant="outlined"
                  size="small"
                  name="codigoOrdenEnvio"
                  value={searchData.codigoOrdenEnvio}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoGestionAtencion"
                  label="Código de Gestión de Atención"
                  variant="outlined"
                  size="small"
                  name="codigoGestionAtencion"
                  value={searchData.codigoGestionAtencion}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionDesde"
                  label="Desde fecha de generación"
                  variant="outlined"
                  name="fechaCreacionDesde"
                  value={searchData.fechaCreacionDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionDesde(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionHasta"
                  label="Hasta fecha de generación"
                  variant="outlined"
                  name="fechaCreacionHasta"
                  value={searchData.fechaCreacionHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionHasta(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="estado-actual-select-label">Estado actual</InputLabel>
                  <Select
                    labelId="estado-actual-select-label"
                    id="estado-actual-select"
                    name="estadoActual"
                    value={searchData.estadoActual}
                    label="Estado actual"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaEstadoDesde"
                  label="Desde fecha de estado"
                  variant="outlined"
                  name="fechaEstadoDesde"
                  value={searchData.fechaEstadoDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) => handleChangeFechaEstadoDesde(newValue)}
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaEstadoHasta"
                  label="Hasta fecha de estado"
                  variant="outlined"
                  name="fechaEstadoHasta"
                  value={searchData.fechaEstadoHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) => handleChangeFechaEstadoHasta(newValue)}
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros de búsqueda">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={ordenesEnvio}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {openOrdenEnvioDialog && (
        <OrdenEnvioDialog
          idOrdenEnvio={idOrdenEnvio}
          onEnviaAProduccion={handleEnviaAProduccion}
          onClose={handleCloseOrdenEnvioDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default OrdenEnvioTable;
